"use strict";

var PromptConfirmButtonGroup = require("app/shared/components/Prompt/prompt-confirm-button-group");
var CreateTeamPrompt = require("app/shared/components/TeamSelector/create-team-prompt");
var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");

var AddTeamButton = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    users: React.PropTypes.array,
    successPromptAction: React.PropTypes.func,
    disabled: React.PropTypes.bool
  },
  render: function() {
    return <PromptConfirmButtonGroup>
      <CreateTeamPrompt users={this.props.users} onConfirmSuccess={this.props.successPromptAction}/>
      <Button type="primary" disabled={this.props.disabled}>
        <span className="flex-center-all">
          <Icon custom icon="plus" className="c-primaryGreen" />
          <span className="ml-10">Adicionar Equipe</span>
        </span>
      </Button>
    </PromptConfirmButtonGroup>
  }
});

module.exports = AddTeamButton;



// WEBPACK FOOTER //
// ./app/screens/Team/shared/components/add-team-button.jsx